module.exports = __webpack_public_path__ + "static/media/barbuda-24.07ede115.jpg";